import styled from "styled-components";

export const Styles = styled.div`
  &.collapse {
    .table-div__body {
      height: 0;
      opacity: 0;
    }
  }
  &.disabled {
    --table-cell-padding: 2px;
  }
  .is-dropping {
    border: 0.5px solid #b8b8b8cc;
  }
  .is-dragging {
    z-index: 10000;
    position: relative;
    .table-div__tr {
      border: 1px solid #0accccff;
    }
  }
  .table-div {
    overflow-y: hidden;
    padding-bottom: 10px;
  }

  &.pdf-mode {
    width: 100%;

    .table-div {
      width: 100% !important;
    }

    .table-div__header,
    .table-div__row {
      width: 100% !important;
    }

    .table-div__cell {
      white-space: normal;
      overflow-wrap: anywhere;
    }
  }

  .table-div__td {
    position: relative;
  }
  .button-collapse {
    min-width: 70px;
  }

  .deleted {
    display: none;
  }

  .table-div__td.action_cell {
    overflow: visible;
    background: #eefaff;
  }

  .button {
    margin-left: 3px;
    color: white;
    border-radius: 4px;
    padding: 1px 3px;
    height: 20px;
    font-size: 12px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: inline-block;
    &.disabled {
      color: rgba(0, 0, 0, 0.25) !important;
      background: #f5f5f5 !important;
    }
    &.insert-button {
      position: absolute;
      z-index: 10;
      right: 0; // đổi từ left: 0 sang right: 0
      background-color: #001f7f;
      -webkit-clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
      clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);

      &:hover {
        background-color: rgb(9, 62, 219);
      }

      &.top {
        top: -10.5px;
      }

      &.bottom {
        bottom: -10.5px;
      }
    }

    &.remove-button {
      background-color: #ed1c24;
      color: white;
      width: 30px;
      &:hover {
        background-color: rgb(184, 72, 53);
      }
    }

    &.sort-button {
      background-color: #00a2e8;
      height: 20px;
      color: white;
      width: 31px;
      &:hover {
        background-color: rgb(9, 99, 184);
      }
    }
  }
  .ant-form-item-explain-error {
    white-space: break-spaces;
  }
`;
